import {
  ReactNode,
  MouseEventHandler,
  forwardRef,
  UIEventHandler,
} from 'react';
import './view.scss';

interface ViewProps {
  children?: ReactNode;
  className?: string;
  onPress?: MouseEventHandler<HTMLDivElement>;
  onScroll?: UIEventHandler<HTMLDivElement>;
  style?: React.CSSProperties;
  onMouseEnter?: React.MouseEventHandler<HTMLDivElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLDivElement>;
  onTouchStart?: React.TouchEventHandler<HTMLDivElement>;
  onTouchEnd?: React.TouchEventHandler<HTMLDivElement>;
  onTouchMove?: React.TouchEventHandler<HTMLDivElement>;
}

export const View = forwardRef<HTMLDivElement, ViewProps>(
  (
    {
      children,
      className = '',
      onPress,
      onScroll,
      style,
      onMouseEnter,
      onMouseLeave,
      onTouchStart,
      onTouchEnd,
      onTouchMove,
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={`view-card ${className}`}
        onClick={onPress}
        onScroll={onScroll}
        style={style}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
        onTouchMove={onTouchMove}
      >
        {children}
      </div>
    );
  }
);
